/* eslint-disable */
// @ts-nocheck

import { ColumnDef } from '@tanstack/react-table'

import { StatusBadgeWithIcon } from '@/components/newRedesign/components'
import { Container } from '@/interfaces/container'
import { formatDateForTableSeparatedDateAndTime } from '@/utils/helpers'
import { formatAmountWithCode } from '@/utils/currency'

export const getColumns = (
  mainCurrency: string = ''
): ColumnDef<Container>[] => [
  {
    accessorKey: 'operationNumber',
    header: 'No. de operación',
    cell: ({ row }) => <p>{row.original.operationNumber || '-'}</p>,
    enableHiding: false,
  },
  {
    accessorKey: 'name',
    header: 'Nombre / Código',
    cell: ({ row }) => {
      const name = row.original.name || '-'
      const code = row.original.code
      return <span>{code ? `${name} / ${code}` : name}</span>
    },
    enableHiding: false,
  },
  {
    accessorKey: 'status',
    header: 'Estado',
    cell: ({ row }) => (
      <StatusBadgeWithIcon
        status={row.original.status}
        statusType="container"
      />
    ),
    enableHiding: false,
    meta: {
      noWrap: true,
    },
  },
  {
    accessorKey: 'categories',
    header: 'Categorías',
    cell: ({ row }) => (
      <span>
        {Array.isArray(row.original.categories)
          ? row.original.categories.map((cat) => cat.name).join(', ')
          : '-'}
      </span>
    ),
    enableHiding: false,
  },
  {
    accessorKey: 'totalCost',
    header: 'Costo',
    cell: ({ row }) => (
      <span>
        {row.original.totalCost != null
          ? formatAmountWithCode(row.original.totalCost, mainCurrency)
          : '-'}
      </span>
    ),
    enableHiding: false,
  },
  {
    accessorKey: 'percentProductsSales',
    header: '% Vendido',
    cell: ({ row }) => {
      const percent = row.original.percentProductsSales ?? 0
      return (
        <div className="flex items-center gap-2">
          <div className="h-3 flex-1 overflow-hidden rounded bg-gray-200">
            <div
              className="h-3 rounded bg-green-500"
              style={{ width: `${percent}%` }}
            ></div>
          </div>
          <span className="text-xs font-medium" style={{ flexShrink: 0 }}>
            {percent}%
          </span>
        </div>
      )
    },
    enableHiding: false,
    minSize: 150,
  },
  {
    accessorKey: 'totalItems',
    header: 'Total de elementos',
    cell: ({ row }) => <span>{row.original.totalItems || 0}</span>,
    enableHiding: true,
    defaultHidden: true,
  },
  {
    accessorKey: 'createdAt',
    header: 'Creación',
    cell: ({ row }) => {
      const { date, time } = formatDateForTableSeparatedDateAndTime(
        row.original?.createdAt
      )
      return (
        <div className="flex flex-col">
          <span>{date}</span>
          <span>{time}</span>
        </div>
      )
    },
    enableHiding: true,
  },
  {
    accessorKey: 'ownerCompany',
    header: 'Proveedor',
    cell: ({ row }) => <span>{row.original.ownerCompany?.name || '-'}</span>,
    enableHiding: true,
  },
  {
    accessorKey: 'managerCompany',
    header: 'Manejador',
    cell: ({ row }) => <span>{row.original.managerCompany?.name || '-'}</span>,
    enableHiding: true,
  },
  {
    accessorKey: 'importerCompany',
    header: 'Importadora',
    cell: ({ row }) => <span>{row.original.importerCompany?.name || '-'}</span>,
    enableHiding: true,
  },
  {
    accessorKey: 'transporterCompany',
    header: 'Transportista',
    cell: ({ row }) => (
      <span>{row.original.transporterCompany?.name || '-'}</span>
    ),
    enableHiding: true,
  },
  {
    accessorKey: 'storageCompany',
    header: 'Almacenaje',
    cell: ({ row }) => <span>{row.original.storageCompany?.name || '-'}</span>,
    enableHiding: true,
  },
  {
    accessorKey: 'updatedAt',
    header: 'Última actualización',
    cell: ({ row }) => {
      const { date, time } = formatDateForTableSeparatedDateAndTime(
        row.original?.updatedAt
      )
      return (
        <div className="flex flex-col">
          <span>{date}</span>
          <span>{time}</span>
        </div>
      )
    },
    enableHiding: true,
  },
]
